import { normalizeError } from 'core/common/errors';
import {
  ATTRS_ANALYTICS_EVENT_NAME,
  ATTRS_ANALYTICS_FUNNEL_LOCALE,
  ATTRS_ANALYTICS_FUNNEL_NAME,
  SpanName,
} from 'core/common/observability/entities';
import { ObservabilitySystem } from 'core/common/observability/interfaces';
import { PinterestParams } from '../../entities';
import { PinterestService } from '../../interfaces';

export class HttpPinterestService implements PinterestService {
  private funnelName = 'unknown';
  private funnelLocale = 'en';

  constructor(private readonly observabilitySystem: ObservabilitySystem) {}

  onFunnelOpened({ funnelName, funnelLocale }: { funnelName: string; funnelLocale: string }) {
    this.setFunnelName(funnelName);
    this.setFunnelLocale(funnelLocale);
  }

  lead(orderId: string) {
    this.track('lead', {
      event_id: orderId,
      lead_type: 'Newsletter',
    });
  }

  checkout({ price, orderId, currency }: PinterestParams) {
    this.track('checkout', {
      event_id: orderId,
      currency: currency,
      value: price,
    });
  }

  track(name: string, params?: Record<string, unknown>) {
    const spanAttributes = {
      [ATTRS_ANALYTICS_EVENT_NAME]: name,
      [ATTRS_ANALYTICS_FUNNEL_NAME]: this.getFunnelName(),
      [ATTRS_ANALYTICS_FUNNEL_LOCALE]: this.getFunnelLocale(),
    };

    const span = this.observabilitySystem.startSpan(SpanName.TRACK_ANALYTICS_PINTEREST);
    span.setAttributes(spanAttributes);

    try {
      span.addEvent('Pending');
      window.pintrk('track', name, params);

      span.addEvent('Succeed');
      span.succeed();
    } catch (err) {
      const error = normalizeError(err);

      span.addEvent('Failed');
      span.fail(error);
    }
  }

  private getFunnelName() {
    return this.funnelName;
  }

  private setFunnelName(funnelName: string) {
    this.funnelName = funnelName;
  }

  private getFunnelLocale() {
    return this.funnelLocale;
  }

  private setFunnelLocale(funnelLocale: string) {
    this.funnelLocale = funnelLocale;
  }
}
